import React from 'react';
import styled from 'styled-components';
import { Question } from '../../types';
import { theme } from '../../styles/theme';

const CardContainer = styled.div`
  background: white;
  padding: ${theme.spacing.xlarge};
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: ${theme.spacing.large};
`;

const QuestionText = styled.h3`
  font-size: 1.25rem;
  margin-bottom: ${theme.spacing.large};
  color: ${theme.colors.text};
`;

const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium};
`;

const OptionButton = styled.button<{ selected: boolean }>`
  padding: ${theme.spacing.medium};
  border: 1px solid ${props => props.selected ? theme.colors.primary : '#E0E0E0'};
  background-color: ${props => props.selected ? theme.colors.lightBlue : 'white'};
  border-radius: 6px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1rem;
  color: ${theme.colors.text};

  &:hover {
    border-color: ${theme.colors.primary};
    background-color: ${theme.colors.lightBlue};
  }
`;

interface QuestionCardProps {
  question: Question;
  selectedScore?: number;
  onSelect: (score: number) => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({ question, selectedScore, onSelect }) => {
  return (
    <CardContainer>
      <QuestionText>{question.text}</QuestionText>
      <OptionsList>
        {question.options.map((option, idx) => (
          <OptionButton
            key={idx}
            selected={selectedScore === option.score}
            onClick={() => onSelect(option.score)}
          >
            {option.text}
          </OptionButton>
        ))}
      </OptionsList>
    </CardContainer>
  );
};

export default QuestionCard;